import React from "react"
import { Notification } from "gatsby-interface"
import { format } from "date-fns"

export default function CancellationNotification({ periodEnd }) {
  return (
    <Notification
      tone="WARNING"
      content={
        <React.Fragment>
          <span>
            Per your request, your plan is set to cancel on
            <strong
              css={theme => ({
                marginLeft: theme.space[2],
                marginRight: theme.space[2],
              })}
            >
              {format(new Date(periodEnd), `MMMM dd, yyyy`)}!
            </strong>{" "}
            Changing your plan again will not revert the pending cancellation.
            Contact Support if you no longer wish to cancel.
          </span>
        </React.Fragment>
      }
    />
  )
}
